import { toArray } from "../../lib/functions";
import { getBookingFormElementDescription } from "./getBookingFormElementDescription";

export function getElementsFromBookingFormGroup({
  bookingFormGroup,
  passengerIndex,
  cbt,
  isRoomSection = false,
}) {
  if (!bookingFormGroup) {
    return [];
  }

  if (bookingFormGroup.BookingFormElement) {
    const ret = toArray(bookingFormGroup.BookingFormElement).map(
      (bookingFormElement, index) => {
        return getBookingFormElementDescription({
          bookingFormElement,
          passengerIndex: isRoomSection ? index : passengerIndex,
          cbt,
        });
      }
    );

    return getIndexedElementsInSection(ret, passengerIndex);
  }

  const elementsInSection = [];

  toArray(bookingFormGroup.BookingFormGroup)
    .filter((bookingFormGroupInside) => !!bookingFormGroupInside)
    .forEach((bookingFormGroupInside) => {
      const elementsInside = getElementsFromBookingFormGroup({
        bookingFormGroup: bookingFormGroupInside,
        passengerIndex,
        cbt,
      });

      // eslint-disable-next-line no-empty
      if (elementsInside.length === 0) {
      } else if (elementsInside[0].name.includes("phone")) {
        elementsInSection.push(elementsInside);
      } else {
        elementsInside.forEach((elementInside) =>
          elementsInSection.push(elementInside)
        );
      }
    });

  return elementsInSection;
}

function getIndexedElementsInSection(elementsInSection, passengerIndex) {
  return elementsInSection.map((element) => {
    return Array.isArray(element)
      ? element.map((oneElement) => ({
          ...oneElement,
          name:
            passengerIndex !== undefined
              ? `${passengerIndex}-${oneElement.name}`
              : oneElement.name,
        }))
      : {
          ...element,
          name:
            passengerIndex !== undefined
              ? `${passengerIndex}-${element.name}`
              : element.name,
        };
  });
}
